export default __webpack_public_path__ + "locales/pt-BR/Common.json?hash=6524c435b46f51e84d5a6ce62307aff7";